var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFindPw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.93542 8.71387H16.3978C18.7553 8.71387 20.6666 10.5831 20.6666 12.8885V17.8254C20.6666 20.1308 18.7553 22 16.3978 22H7.93542C5.57798 22 3.66663 20.1308 3.66663 17.8254V12.8885C3.66663 10.5831 5.57798 8.71387 7.93542 8.71387ZM12.1615 17.3295C12.6594 17.3295 13.0557 16.942 13.0557 16.455V14.2489C13.0557 13.772 12.6594 13.3844 12.1615 13.3844C11.6738 13.3844 11.2775 13.772 11.2775 14.2489V16.455C11.2775 16.942 11.6738 17.3295 12.1615 17.3295Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.6895 7.39595V8.86667C17.3338 8.7673 16.9579 8.71761 16.5717 8.71761H15.9112V7.39595C15.9112 5.37868 14.2346 3.73903 12.1718 3.73903C10.1091 3.73903 8.43245 5.36874 8.42229 7.37608V8.71761H7.77196C7.37566 8.71761 6.99969 8.7673 6.64404 8.87661V7.39595C6.6542 4.41476 9.12342 2 12.1515 2C15.2203 2 17.6895 4.41476 17.6895 7.39595Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindPw);
export default __webpack_public_path__ + "static/media/find_pw.6527060d44f52f36c95cc1d9d2436f45.svg";
export { ForwardRef as ReactComponent };